import { jsx } from "react/jsx-runtime";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import { validateTidalLicense } from "../../base/index.js";
function BuildCircle(props) {
  return /* @__PURE__ */ jsx(
    BuildCircleIcon,
    {
      "data-testid": "BuildCircle",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "BuildCircle",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
BuildCircle.tidalIconMeta = {
  categories: "miscellaneous",
  name: "BuildCircle"
};
validateTidalLicense();
export {
  BuildCircle
};
//# sourceMappingURL=BuildCircle.js.map
